import * as types from "./configurationActionType";

export const acquireTaskSequenceLockRequest = (requestId, startDateTime = null) => ({
  type: types.ACQUIRE_TASK_SEQUENCE_LOCK_REQUEST,
  payload: { requestId, StartDateTime: startDateTime },
});
export const releaseTaskSequenceLockRequest = (startDateTime) => ({
  type: types.RELEASE_TASK_SEQUENCE_LOCK_REQUEST,
  payload: { StartDateTime: startDateTime },
});
export const cancelTaskSequenceLockRequest = (requestId) => ({
  type: types.CANCEL_TASK_SEQUENCE_LOCK_REQUEST,
  payload: { requestId },
});
// Site Coverage Actions
export const fetchSiteCoverageDetailsRequest = (filters = {}) => ({
  type: types.FETCH_SITE_COVERAGE_DETAILS_REQUEST,
  payload: filters,
});

export const fetchSiteCoverageDetailsSuccess = (data) => ({
  type: types.FETCH_SITE_COVERAGE_DETAILS_SUCCESS,
  payload: data,
});

export const fetchSiteCoverageDetailsFailure = (error) => ({
  type: types.FETCH_SITE_COVERAGE_DETAILS_FAILURE,
  payload: error,
});

// Site Coverage Details By ID Actions
export const fetchSiteCoverageDetailByIdRequest = (siteCoverageID) => ({
  type: types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_REQUEST,
  payload: { siteCoverageID },
});

export const fetchSiteCoverageDetailByIdSuccess = (data) => ({
  type: types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_SUCCESS,
  payload: data,
});

export const fetchSiteCoverageDetailByIdFailure = (error) => ({
  type: types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_FAILURE,
  payload: error,
});

// Delete Site Coverage Detail Actions
export const deleteSiteCoverageDetailRequest = (data) => ({
  type: types.DELETE_SITE_COVERAGE_DETAIL_REQUEST,
  payload: data,
});

export const deleteSiteCoverageDetailSuccess = (data) => ({
  type: types.DELETE_SITE_COVERAGE_DETAIL_SUCCESS,
  payload: data,
});

export const deleteSiteCoverageDetailFailure = (error) => ({
  type: types.DELETE_SITE_COVERAGE_DETAIL_FAILURE,
  payload: error,
});

// Save Site Coverage Detail Actions
export const saveSiteCoverageDetailRequest = (data, onSuccess = null) => ({
  type: types.SAVE_SITE_COVERAGE_DETAIL_REQUEST,
  payload: data,
  onSuccess,
});

export const saveSiteCoverageDetailSuccess = (data) => ({
  type: types.SAVE_SITE_COVERAGE_DETAIL_SUCCESS,
  payload: data,
});

export const saveSiteCoverageDetailFailure = (error) => ({
  type: types.SAVE_SITE_COVERAGE_DETAIL_FAILURE,
  payload: error,
});

// Coverage Gap Actions
export const fetchCoverageGapRequest = () => ({
  type: types.FETCH_COVERAGE_GAP_REQUEST,
});

export const fetchCoverageGapSuccess = (data) => ({
  type: types.FETCH_COVERAGE_GAP_SUCCESS,
  payload: data,
});

export const fetchCoverageGapFailure = (error) => ({
  type: types.FETCH_COVERAGE_GAP_FAILURE,
  payload: error,
});

// Save Coverage Gap Actions
export const saveCoverageGapRequest = (data, onSuccess = null) => ({
  type: types.SAVE_COVERAGE_GAP_REQUEST,
  payload: data,
  onSuccess,
});

export const saveCoverageGapSuccess = (data) => ({
  type: types.SAVE_COVERAGE_GAP_SUCCESS,
  payload: data,
});

export const saveCoverageGapFailure = (error) => ({
  type: types.SAVE_COVERAGE_GAP_FAILURE,
  payload: error,
});

// Delete Coverage Gap Actions
export const deleteCoverageGapRequest = (RVUConfigurationID, ModifiedBy) => ({
  type: types.DELETE_COVERAGE_GAP_REQUEST,
  payload: { RVUConfigurationID, ModifiedBy },
});

export const deleteCoverageGapSuccess = (data) => ({
  type: types.DELETE_COVERAGE_GAP_SUCCESS,
  payload: data,
});
export const deleteCoverageGapFailure = (error) => ({
  type: types.DELETE_COVERAGE_GAP_FAILURE,
  payload: error,
});

// Fetch Coverage Gap By ID Actions
export const fetchCoverageGapByIdRequest = (RVUConfigurationID) => ({
  type: types.FETCH_COVERAGE_GAP_BY_ID_REQUEST,
  payload: { RVUConfigurationID },
});
export const fetchCoverageGapByIdSuccess = (data) => ({
  type: types.FETCH_COVERAGE_GAP_BY_ID_SUCCESS,
  payload: data,
});
export const fetchCoverageGapByIdFailure = (error) => ({
  type: types.FETCH_COVERAGE_GAP_BY_ID_FAILURE,
  payload: error,
});

// Priority SLA Mapping Actions
export const fetchPrioritySLAMappingsRequest = () => ({
  type: types.FETCH_PRIORITY_SLA_MAPPINGS_REQUEST,
});

export const fetchPrioritySLAMappingsSuccess = (data) => ({
  type: types.FETCH_PRIORITY_SLA_MAPPINGS_SUCCESS,
  payload: data,
});

export const fetchPrioritySLAMappingsFailure = (error) => ({
  type: types.FETCH_PRIORITY_SLA_MAPPINGS_FAILURE,
  payload: error,
});

export const fetchPrioritySLAMappingByIdRequest = (id) => ({
  type: types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_REQUEST,
  payload: id,
});

export const fetchPrioritySLAMappingByIdSuccess = (data) => ({
  type: types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_SUCCESS,
  payload: data,
});

export const fetchPrioritySLAMappingByIdFailure = (error) => ({
  type: types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_FAILURE,
  payload: error,
});

export const savePrioritySLAMappingRequest = (data, onSuccess = null) => ({
  type: types.SAVE_PRIORITY_SLA_MAPPING_REQUEST,
  payload: data,
  onSuccess,
});

export const savePrioritySLAMappingSuccess = (data) => ({
  type: types.SAVE_PRIORITY_SLA_MAPPING_SUCCESS,
  payload: data,
});

export const savePrioritySLAMappingFailure = (error) => ({
  type: types.SAVE_PRIORITY_SLA_MAPPING_FAILURE,
  payload: error,
});

export const deletePrioritySLAMappingRequest = (id) => ({
  type: types.DELETE_PRIORITY_SLA_MAPPING_REQUEST,
  payload: id,
});

export const deletePrioritySLAMappingSuccess = (id) => ({
  type: types.DELETE_PRIORITY_SLA_MAPPING_SUCCESS,
  payload: id,
});

export const deletePrioritySLAMappingFailure = (error) => ({
  type: types.DELETE_PRIORITY_SLA_MAPPING_FAILURE,
  payload: error,
});

export const dropdownPriorityRequest = () => ({
  type: types.DROPDOWN_PRIORITY_REQUEST,
});
export const dropdownPrioritySuccess = (data) => ({
  type: types.DROPDOWN_PRIORITY_SUCCESS,
  payload: data,
});
export const dropdownPriorityFailure = (error) => ({
  type: types.DROPDOWN_PRIORITY_FAILURE,
  payload: error,
});

export const activateDeactivatePrioritySLAMappingRequest = (
  mappingId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_REQUEST,
  payload: { mappingId, status, userId },
});

export const activateDeactivatePrioritySLAMappingSuccess = (data) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_SUCCESS,
  payload: data,
});

export const activateDeactivatePrioritySLAMappingFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_FAILURE,
  payload: error,
});

export const fetchPrioritySLABucketsRequest = () => ({
  type: types.FETCH_PRIORITY_SLA_BUCKETS_REQUEST,
});

export const fetchPrioritySLABucketsSuccess = (data) => ({
  type: types.FETCH_PRIORITY_SLA_BUCKETS_SUCCESS,
  payload: data,
});

export const fetchPrioritySLABucketsFailure = (error) => ({
  type: types.FETCH_PRIORITY_SLA_BUCKETS_FAILURE,
  payload: error,
});

// License Mapping Actions
export const fetchStateLicenseMappingRequest = () => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_REQUEST,
});

export const fetchStateLicenseMappingSuccess = (data) => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_SUCCESS,
  payload: data,
});

export const fetchStateLicenseMappingFailure = (error) => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_FAILURE,
  payload: error,
});

export const fetchStateLicenseMappingDropdownRequest = () => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_REQUEST,
});

export const fetchStateLicenseMappingDropdownSuccess = (data) => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_SUCCESS,
  payload: data,
});

export const fetchStateLicenseMappingDropdownFailure = (error) => ({
  type: types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_FAILURE,
  payload: error,
});

export const saveStateLicenseMappingBulkRequest = (data) => ({
  type: types.SAVE_STATE_LICENSE_MAPPING_BULK_REQUEST,
  payload: data,
});

export const saveStateLicenseMappingBulkSuccess = (data) => ({
  type: types.SAVE_STATE_LICENSE_MAPPING_BULK_SUCCESS,
  payload: data,
});

export const saveStateLicenseMappingBulkFailure = (error) => ({
  type: types.SAVE_STATE_LICENSE_MAPPING_BULK_FAILURE,
  payload: error,
});

// Privileges Mapping Actions
export const fetchPrivilegesMappingRequest = () => ({
  type: types.FETCH_PRIVILEGES_MAPPING_REQUEST,
});

export const fetchPrivilegesMappingSuccess = (data) => ({
  type: types.FETCH_PRIVILEGES_MAPPING_SUCCESS,
  payload: data,
});

export const fetchPrivilegesMappingFailure = (error) => ({
  type: types.FETCH_PRIVILEGES_MAPPING_FAILURE,
  payload: error,
});

export const fetchPrivilegesMappingDropdownRequest = () => ({
  type: types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_REQUEST,
});

export const fetchPrivilegesMappingDropdownSuccess = (data) => ({
  type: types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_SUCCESS,
  payload: data,
});

export const fetchPrivilegesMappingDropdownFailure = (error) => ({
  type: types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_FAILURE,
  payload: error,
});

export const savePrivilegesMappingBulkRequest = (data) => ({
  type: types.SAVE_PRIVILEGES_MAPPING_BULK_REQUEST,
  payload: data,
});

export const savePrivilegesMappingBulkSuccess = (data) => ({
  type: types.SAVE_PRIVILEGES_MAPPING_BULK_SUCCESS,
  payload: data,
});

export const savePrivilegesMappingBulkFailure = (error) => ({
  type: types.SAVE_PRIVILEGES_MAPPING_BULK_FAILURE,
  payload: error,
});

// Reading Status Mapping Actions
export const fetchReadingStatusMappingRequest = () => ({
  type: types.FETCH_READING_STATUS_MAPPING_REQUEST,
});

export const fetchReadingStatusMappingSuccess = (data) => ({
  type: types.FETCH_READING_STATUS_MAPPING_SUCCESS,
  payload: data,
});

export const fetchReadingStatusMappingFailure = (error) => ({
  type: types.FETCH_READING_STATUS_MAPPING_FAILURE,
  payload: error,
});

export const fetchReadingStatusMappingDropdownRequest = () => ({
  type: types.FETCH_READING_STATUS_MAPPING_DROPDOWN_REQUEST,
});

export const fetchReadingStatusMappingDropdownSuccess = (data) => ({
  type: types.FETCH_READING_STATUS_MAPPING_DROPDOWN_SUCCESS,
  payload: data,
});

export const fetchReadingStatusMappingDropdownFailure = (error) => ({
  type: types.FETCH_READING_STATUS_MAPPING_DROPDOWN_FAILURE,
  payload: error,
});

export const saveReadingStatusMappingBulkRequest = (data) => ({
  type: types.SAVE_READING_STATUS_MAPPING_BULK_REQUEST,
  payload: data,
});

export const saveReadingStatusMappingBulkSuccess = (data) => ({
  type: types.SAVE_READING_STATUS_MAPPING_BULK_SUCCESS,
  payload: data,
});

export const saveReadingStatusMappingBulkFailure = (error) => ({
  type: types.SAVE_READING_STATUS_MAPPING_BULK_FAILURE,
});

export const fetchDefineMismatchRequest = () => ({
  type: types.FETCH_DEFINE_MISMATCH_REQUEST,
});

export const fetchDefineMismatchSuccess = (data) => ({
  type: types.FETCH_DEFINE_MISMATCH_SUCCESS,
  payload: data,
});

export const fetchDefineMismatchFailure = (error) => ({
  type: types.FETCH_DEFINE_MISMATCH_FAILURE,
  payload: error,
});

export const fetchDefineMismatchDropdownRequest = () => ({
  type: types.FETCH_DEFINE_MISMATCH_DROPDOWN_REQUEST,
});

export const fetchDefineMismatchDropdownSuccess = (data) => ({
  type: types.FETCH_DEFINE_MISMATCH_DROPDOWN_SUCCESS,
  payload: data,
});

export const fetchDefineMismatchDropdownFailure = (error) => ({
  type: types.FETCH_DEFINE_MISMATCH_DROPDOWN_FAILURE,
  payload: error,
});

export const saveDefineMismatchRequest = (data) => ({
  type: types.SAVE_DEFINE_MISMATCH_REQUEST,
  payload: data,
});

export const saveDefineMismatchSuccess = (data) => ({
  type: types.SAVE_DEFINE_MISMATCH_SUCCESS,
  payload: data,
});

export const saveDefineMismatchFailure = (error) => ({
  type: types.SAVE_DEFINE_MISMATCH_FAILURE,
  payload: error,
});

export const activateDeactivateDefineMismatchRequest = (data) => ({
  type: types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_REQUEST,
  payload: data,
});

export const activateDeactivateDefineMismatchSuccess = (data) => ({
  type: types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_SUCCESS,
  payload: data,
});

export const activateDeactivateDefineMismatchFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_FAILURE,
  payload: error,
});

export const deleteDefineMismatchRequest = (data) => ({
  type: types.DELETE_DEFINE_MISMATCH_REQUEST,
  payload: data,
});

export const deleteDefineMismatchSuccess = (data) => ({
  type: types.DELETE_DEFINE_MISMATCH_SUCCESS,
  payload: data,
});

export const deleteDefineMismatchFailure = (error) => ({
  type: types.DELETE_DEFINE_MISMATCH_FAILURE,
  payload: error,
});

// Shift Hour Configuration Actions
export const fetchShiftHourRequest = () => ({
  type: types.FETCH_SHIFT_HOUR_REQUEST,
});

export const fetchShiftHourSuccess = (data) => ({
  type: types.FETCH_SHIFT_HOUR_SUCCESS,
  payload: data,
});

export const fetchShiftHourFailure = (error) => ({
  type: types.FETCH_SHIFT_HOUR_FAILURE,
  payload: error,
});

//--------------------- DLS Configuration Actions - Start---------------------//
// DLS Configuration Actions
export const fetchDLSConfigurationRequest = () => ({
  type: types.FETCH_DLS_CONFIGURATION_REQUEST,
});
export const fetchDLSConfigurationSuccess = (data) => ({
  type: types.FETCH_DLS_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchDLSConfigurationFailure = (error) => ({
  type: types.FETCH_DLS_CONFIGURATION_FAILURE,
  payload: error,
});

// Sites Without DLS Actions
export const fetchSitesWithoutDLSRequest = () => ({
  type: types.FETCH_SITES_WITHOUT_DLS_REQUEST,
});
export const fetchSitesWithoutDLSSuccess = (data) => ({
  type: types.FETCH_SITES_WITHOUT_DLS_SUCCESS,
  payload: data,
});
export const fetchSitesWithoutDLSFailure = (error) => ({
  type: types.FETCH_SITES_WITHOUT_DLS_FAILURE,
  payload: error,
});

// Save DLS Configuration Actions
export const saveDLSConfigurationRequest = (data, onSuccess = null) => ({
  type: types.SAVE_DLS_CONFIGURATION_REQUEST,
  payload: data,
  onSuccess,
});
export const saveDLSConfigurationSuccess = (data) => ({
  type: types.SAVE_DLS_CONFIGURATION_SUCCESS,
  payload: data,
});
export const saveDLSConfigurationFailure = (error) => ({
  type: types.SAVE_DLS_CONFIGURATION_FAILURE,
  payload: error,
});
//--------------------- DLS Configuration Actions - End---------------------//

//Block Planning Actions
export const fetchBlockPlanningRequest = () => ({
  type: types.FETCH_BLOCK_PLANNING_REQUEST,
});

export const fetchBlockPlanningSuccess = (data) => ({
  type: types.FETCH_BLOCK_PLANNING_SUCCESS,
  payload: data,
});

export const fetchBlockPlanningFailure = (error) => ({
  type: types.FETCH_BLOCK_PLANNING_FAILURE,
  payload: error,
});

// Block Planning Details By ID Actions
export const fetchBlockPlanningDetailByIdRequest = (
  blockPlanningColorConfigurationID,
) => ({
  type: types.FETCH_BLOCK_PLANNING_BY_ID_REQUEST,
  payload: { blockPlanningColorConfigurationID },
});

export const fetchBlockPlanningDetailByIdSuccess = (data) => ({
  type: types.FETCH_BLOCK_PLANNING_BY_ID_SUCCESS,
  payload: data,
});

export const fetchBlockPlanningDetailByIdFailure = (error) => ({
  type: types.FETCH_BLOCK_PLANNING_BY_ID_FAILURE,
  payload: error,
});
// Delete Block Planning Detail Actions
export const deleteBlockPlanningRequest = (
  BlockPlanningColorConfigurationID,
  ModifiedBy,
) => ({
  type: types.DELETE_BLOCK_PLANNING_REQUEST,
  payload: { BlockPlanningColorConfigurationID, ModifiedBy },
});

export const deleteBlockPlanningSuccess = (data) => ({
  type: types.DELETE_BLOCK_PLANNING_SUCCESS,
  payload: data,
});
export const deleteBlockPlanningFailure = (error) => ({
  type: types.DELETE_BLOCK_PLANNING_FAILURE,
  payload: error,
});

// Save Block Planning Detail Actions
export const saveBlockPlanningRequest = (data, onSuccess = null) => ({
  type: types.SAVE_BLOCK_PLANNING_REQUEST,
  payload: data,
  onSuccess,
});
export const saveBlockPlanningSuccess = (data) => ({
  type: types.SAVE_BLOCK_PLANNING_SUCCESS,
  payload: data,
});
export const saveBlockPlanningFailure = (error) => ({
  type: types.SAVE_BLOCK_PLANNING_FAILURE,
  payload: error,
});

//--------------------- Day of Week Configuration Actions - Start---------------------//
// Day of Week Configuration Actions
export const fetchDayOfWeekConfigurationRequest = () => ({
  type: types.FETCH_DAY_OF_WEEK_CONFIGURATION_REQUEST,
});
export const fetchDayOfWeekConfigurationSuccess = (data) => ({
  type: types.FETCH_DAY_OF_WEEK_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchDayOfWeekConfigurationFailure = (error) => ({
  type: types.FETCH_DAY_OF_WEEK_CONFIGURATION_FAILURE,
  payload: error,
});
//--------------------- Day of Week Configuration Actions - End---------------------//
// Task Configuration Actions
export const fetchTaskConfigurationRequestRequest = (payload = {}) => ({
  type: types.FETCH_TASK_CONFIGURATION_DETAILS_REQUEST,
  payload,
});

export const fetchTaskConfigurationRequestSuccess = (data) => ({
  type: types.FETCH_TASK_CONFIGURATION_DETAILS_SUCCESS,
  payload: data,
});

export const fetchTaskConfigurationRequestFailure = (error) => ({
  type: types.FETCH_TASK_CONFIGURATION_DETAILS_FAILURE,
  payload: error,
});

// Save Task congiguration Actions
export const saveTaskConfigurationRequest = (data) => ({
  type: types.SAVE_TASK_CONFIGURATION_REQUEST,
  payload: data,
});
export const saveTaskConfigurationSuccess = (data) => ({
  type: types.SAVE_TASK_CONFIGURATION_SUCCESS,
  payload: data,
});
export const saveTaskConfigurationFailure = (error) => ({
  type: types.SAVE_TASK_CONFIGURATION_FAILURE,
  payload: error,
});

// Delete Task Configuration Actions
export const deleteTaskConfigurationRequest = (payload) => ({
  type: types.DELETE_TASK_CONFIGURATION_REQUEST,
  payload,
});

export const deleteTaskConfigurationSuccess = (data) => ({
  type: types.DELETE_TASK_CONFIGURATION_SUCCESS,
  payload: data,
});
export const deleteTaskConfigurationFailure = (error) => ({
  type: types.DELETE_TASK_CONFIGURATION_FAILURE,
  payload: error,
});

//Task Configuration Details By ID Actions
export const fetchTaskConfigurationByIdRequest = (taskConfigurationID) => ({
  type: types.FETCH_TASK_CONFIGURATION_BY_ID_REQUEST,
  payload: { taskConfigurationID },
});

export const fetchTaskConfigurationByIdSuccess = (data) => ({
  type: types.FETCH_TASK_CONFIGURATION_BY_ID_SUCCESS,
  payload: data,
});

export const fetchTaskConfigurationByIdFailure = (error) => ({
  type: types.FETCH_TASK_CONFIGURATION_BY_ID_FAILURE,
  payload: error,
});

//Activate Deactivate Task Configuration Actions
export const activateDeactivateTaskConfigurationRequest = (
  taskConfigurationID,
  isActive,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_REQUEST,
  payload: { taskConfigurationID, isActive, userId },
});
export const activateDeactivatefetchTaskConfigurationByIdSuccess = (
  taskConfiguration,
) => ({
  type: types.FETCH_TASK_CONFIGURATION_BY_ID_SUCCESS,
  payload: taskConfiguration,
});
export const activateDeactivatefetchTaskConfigurationByIdFailure = (error) => ({
  type: types.FETCH_TASK_CONFIGURATION_BY_ID_FAILURE,
  payload: error,
});

//Save Task Sequence Actions
export const saveTaskSequenceRequest = (payload) => ({
  type: types.SAVE_TASK_SEQUENCE_REQUEST,
  payload,
});
export const saveTaskSequenceSuccess = (data) => ({
  type: types.SAVE_TASK_SEQUENCE_SUCCESS,
  payload: data,
});
export const saveTaskSequenceFailure = (error) => ({
  type: types.SAVE_TASK_SEQUENCE_FAILURE,
  payload: error,
});

export const taskBulkUpdateRequest = (data) => ({
  type: types.TASK_BULK_UPDATE_REQUEST,
  payload: data,
});

export const taskBulkUpdateSuccess = (data) => ({
  type: types.TASK_BULK_UPDATE_SUCCESS,
  payload: data,
});

export const taskBulkUpdateFailure = (error) => ({
  type: types.TASK_BULK_UPDATE_FAILURE,
  payload: error,
});

// Task Tags Actions
export const fetchTaskTagsRequest = (taskId) => ({
  type: types.FETCH_TASK_TAGS_REQUEST,
  payload: { taskId },
});

export const fetchTaskTagsSuccess = (data) => ({
  type: types.FETCH_TASK_TAGS_SUCCESS,
  payload: data,
});

export const fetchTaskTagsFailure = (error) => ({
  type: types.FETCH_TASK_TAGS_FAILURE,
  payload: error,
});

export const saveTaskTagsRequest = (data, onSuccess = null) => ({
  type: types.SAVE_TASK_TAGS_REQUEST,
  payload: { data, onSuccess },
});

export const saveTaskTagsSuccess = (data) => ({
  type: types.SAVE_TASK_TAGS_SUCCESS,
  payload: data,
});

export const saveTaskTagsFailure = (error) => ({
  type: types.SAVE_TASK_TAGS_FAILURE,
  payload: error,
});

// Provider Task Pool Actions
export const fetchProviderTaskPoolRequest = (taskId) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_REQUEST,
  payload: { taskId },
});

export const fetchProviderTaskPoolSuccess = (data) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_SUCCESS,
  payload: data,
});

export const fetchProviderTaskPoolFailure = (error) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_FAILURE,
  payload: error,
});

export const saveProviderTaskPoolRequest = (data, onSuccess = null) => ({
  type: types.SAVE_PROVIDER_TASK_POOL_REQUEST,
  payload: { data, onSuccess },
});

export const saveProviderTaskPoolSuccess = (data) => ({
  type: types.SAVE_PROVIDER_TASK_POOL_SUCCESS,
  payload: data,
});

export const saveProviderTaskPoolFailure = (error) => ({
  type: types.SAVE_PROVIDER_TASK_POOL_FAILURE,
  payload: error,
});

export const fetchProviderTaskPoolProviderOptionsRequest = (taskId) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_REQUEST,
  payload: { taskId },
});

export const fetchProviderTaskPoolProviderOptionsSuccess = (data) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_SUCCESS,
  payload: data,
});

export const fetchProviderTaskPoolProviderOptionsFailure = (error) => ({
  type: types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_FAILURE,
  payload: error,
});

export const addProviderTaskPoolProvidersRequest = (data, onSuccess = null) => ({
  type: types.ADD_PROVIDER_TASK_POOL_PROVIDERS_REQUEST,
  payload: { data, onSuccess },
});

export const addProviderTaskPoolProvidersSuccess = (data) => ({
  type: types.ADD_PROVIDER_TASK_POOL_PROVIDERS_SUCCESS,
  payload: data,
});

export const addProviderTaskPoolProvidersFailure = (error) => ({
  type: types.ADD_PROVIDER_TASK_POOL_PROVIDERS_FAILURE,
  payload: error,
});

export const removeProviderTaskPoolProviderRequest = (
  data,
  onSuccess = null,
) => ({
  type: types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_REQUEST,
  payload: { data, onSuccess },
});

export const removeProviderTaskPoolProviderSuccess = (data) => ({
  type: types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_SUCCESS,
  payload: data,
});

export const removeProviderTaskPoolProviderFailure = (error) => ({
  type: types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_FAILURE,
  payload: error,
});

export const exportProviderTaskPoolRequest = (taskId, taskName = "") => ({
  type: types.EXPORT_PROVIDER_TASK_POOL_REQUEST,
  payload: { taskId, taskName },
});

export const exportProviderTaskPoolSuccess = (data) => ({
  type: types.EXPORT_PROVIDER_TASK_POOL_SUCCESS,
  payload: data,
});

export const exportProviderTaskPoolFailure = (error) => ({
  type: types.EXPORT_PROVIDER_TASK_POOL_FAILURE,
  payload: error,
});
//--------------------- Simulation Actions Start---------------------//
//get all Simulations Actions
export const fetchSimulationRequest = () => ({
  type: types.FETCH_SIMULATION_REQUEST,
});
export const fetchSimulationSuccess = (data) => ({
  type: types.FETCH_SIMULATION_SUCCESS,
  payload: data,
});
export const fetchSimulationFailure = (error) => ({
  type: types.FETCH_SIMULATION_FAILURE,
  payload: error,
});
// Save Simulation Actions
export const saveSimulationRequest = (data, onSuccess = null) => ({
  type: types.SAVE_SIMULATION_REQUEST,
  payload: data,
  onSuccess,
});
export const saveSimulationSuccess = (data) => ({
  type: types.SAVE_SIMULATION_SUCCESS,
  payload: data,
});
export const saveSimulationFailure = (error) => ({
  type: types.SAVE_SIMULATION_FAILURE,
  payload: error,
});
// Delete Simulation Actions
export const deleteSimulationRequest = (SimulatorLegendId, ModifiedBy) => ({
  type: types.DELETE_SIMULATION_REQUEST,
  payload: { SimulatorLegendId, ModifiedBy },
});
export const deleteSimulationSuccess = (data) => ({
  type: types.DELETE_SIMULATION_SUCCESS,
  payload: data,
});
export const deleteSimulationFailure = (error) => ({
  type: types.DELETE_SIMULATION_FAILURE,
  payload: error,
});
// Fetch Simulation By ID Actions
export const fetchSimulationByIdRequest = (SimulatorLegendId) => ({
  type: types.FETCH_SIMULATION_BY_ID_REQUEST,
  payload: { SimulatorLegendId },
});
export const fetchSimulationByIdSuccess = (data) => ({
  type: types.FETCH_SIMULATION_BY_ID_SUCCESS,
  payload: data,
});
export const fetchSimulationByIdFailure = (error) => ({
  type: types.FETCH_SIMULATION_BY_ID_FAILURE,
  payload: error,
});
//--------------------- Simulation Actions End---------------------//

//--------------------- Email Configuration Actions Start---------------------//
//get all Email Configuration Actions
export const fetchEmailConfigurationRequest = () => ({
  type: types.FETCH_EMAIL_CONFIGURATION_REQUEST,
});
export const fetchEmailConfigurationSuccess = (data) => ({
  type: types.FETCH_EMAIL_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchEmailConfigurationFailure = (error) => ({
  type: types.FETCH_EMAIL_CONFIGURATION_FAILURE,
  payload: error,
});
// Save Email Configuration Actions
export const saveEmailConfigurationRequest = (data) => ({
  type: types.SAVE_EMAIL_CONFIGURATION_REQUEST,
  payload: data,
});
export const saveEmailConfigurationSuccess = (data) => ({
  type: types.SAVE_EMAIL_CONFIGURATION_SUCCESS,
  payload: data,
});
export const saveEmailConfigurationFailure = (error) => ({
  type: types.SAVE_EMAIL_CONFIGURATION_FAILURE,
  payload: error,
});
//--------------------- Email Configuration Actions End---------------------//

// Update Configuration Reducer
export const updateConfigurationReducer = (data) => ({
  type: types.UPDATE_CONFIGURATION_REDUCER,
  payload: data,
});
